/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Item_Last_Message_PreviewInputs */



/**
* | output |
* | --- |
* | "Last message preview:" |
*
* @param {Chat_Item_Last_Message_PreviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_item_last_message_preview = /** @type {((inputs?: Chat_Item_Last_Message_PreviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Item_Last_Message_PreviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau der letzten Nachricht:")
	return /** @type {LocalizedString} */ ("Last message preview:")
});